import React from 'react';
import Layout from '../components/Layout.jsx';
import './Induction.css';

const Induction = () => {
  const API_BASE_URL = process.env.REACT_APP_API_URL || '';
  const pdfUrl = API_BASE_URL
    ? `${API_BASE_URL.replace(/\/$/, '')}/uploads/HR-Induction-BuildINT.pdf`
    : '/uploads/HR-Induction-BuildINT.pdf';

  return (
    <Layout>
      <div className="page-header" style={{ marginBottom: "2rem" }}>
        <div className="pagetitle">
          <h1>Company Induction</h1>
          <p style={{ margin: '0.5rem 0 0 0', color: '#666' }}>
            Please review the induction document below.
          </p>
        </div>
      </div>

      <section className="section">
        <div className="induction-document-container">
          <div className="pdf-viewer">
            <iframe
              src={`${pdfUrl}#toolbar=1`}
              title="Company Induction Document"
              width="100%"
              height="800px"
              style={{
                border: '1px solid #dee2e6',
                borderRadius: '6px'
              }}
            ></iframe>
          </div>

          {/* <div className="document-controls">
            <a
              href={pdfUrl}
              download="HR-Induction-BuildINT.pdf"
              className="btn btn-primary"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.75rem 1.5rem',
                textDecoration: 'none',
                borderRadius: '4px',
                backgroundColor: '#0d6efd',
                color: 'white',
                fontWeight: '500'
              }}
            >
              <i className="bi bi-download"></i>
              Download PDF
            </a>
          </div> */}
        </div>
      </section>
    </Layout>
  );
};

export default Induction;
